const prefix = 'vue-auth-cognito'

export const AUTHENTICATE = `${prefix}/AUTHENTICATE`
export const ATTRIBUTES = `${prefix}/ATTRIBUTES`
export const CREDENTIALS = `${prefix}/CREDENTIALS`
export const SIGNOUT = `${prefix}/SIGNOUT`
export const AUTH_CHALLENGE = `${prefix}/AUTH_CHALLENGE`
